module.exports = __webpack_public_path__ + "static/media/dialog.02bb8a11.png";